module.exports = __webpack_public_path__ + "media/img/sbt-test/Scholarships2u-Successful-Application-7fda0f3e2bdd1d3ced1e0b9329d2923b.svg";